var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useEffect, useState } from "react";
export function useIsDesktop() {
    // return useMediaQuery("(hover: hover) or (pointer: fine)");
    var _a = __read(useState(function () { return window.matchMedia("(min-width: 720px)").matches; }), 2), isDesktop = _a[0], setIsDesktop = _a[1];
    useEffect(function () {
        var match = window.matchMedia("(min-width: 720px)");
        function listener(e) {
            setIsDesktop(e.matches);
        }
        match.addEventListener("change", listener);
        return function () {
            match.removeEventListener("change", listener);
        };
    }, []);
    return isDesktop;
}
